<div class="context-menu-container" style="top: -99999em;" *ngIf="isOpen">
  <ng-content></ng-content>
</div>

